import React from 'react';
import { string } from 'prop-types';
import { Link } from 'react-router-dom';

import { loggedIn } from '../../lib/auth';

import cx from 'classnames';
import s from './Header.css';
import { ChevronLeft } from 'react-feather';


const Header = ({ practiceName, conversationHash }) => {
    if (loggedIn()) {
        return (
            <React.Fragment>
                <div className={s.filler} />
                <nav className={s.component}>
                    <p className={cx(s.practiceName, s.truncate)}>
                        {practiceName}
                    </p>
                    <section className={cx(s.flex, (!conversationHash ? s.linkRight : null))}>
                        {conversationHash &&
                            <Link
                                className={s.link}
                                id="linkToAllConversations"
                                to={`/menu/${conversationHash}`}
                            >
                                <ChevronLeft className={s.icon} size={12} />
                                All Conversations
                            </Link>
                        }
                        <Link
                            className={cx(s.link)}
                            id="linkToLeaveSession"
                            to="/logout"
                        >
                            Log out
                        </Link>
                    </section>

                </nav>
            </React.Fragment>
        );
    }

    return null;
};

Header.propTypes = {
    practiceName: string,
    conversationHash: string,
};

export default Header;
